// extracted by mini-css-extract-plugin
export var parcelRow = "_us-0";